<div class="grid">
  <app-error-info
    *ngIf="!isError; else errorMessage"
    [errorInfo]="noResultsError"
    [showAdditionalData]="!hasFilters"></app-error-info>
  <ng-template #errorMessage>
    <app-error-info [errorInfo]="notAvailableError"></app-error-info>
  </ng-template>
</div>
